import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const IndividualAlarmService = {
    search: async (payload, {page, size, sort}) => axios.post(`${API_KEEPER}/individual/alarm/search?page=${page}&size=${size}&sort=${sort}`, payload)
        .then(({data}) => data)
        .catch((err) => { throw err }),

    sign: async (id) => axios.post(`${API_KEEPER}/individual/alarm/sign/${id}`)
        .then(({data}) => data)
        .catch((err) => { throw err }),

    providers: async () => axios.get(`${API_KEEPER}/individual/providers`)
        .then(({data}) => data
            .filter(item => Boolean(item.name?.trim()))
            .map(item => ({value: item.id, label: item.name, type: item.type}))
        )
        .catch((err) => { throw err }),
};

export default IndividualAlarmService;
